/**
 * Session — the backoffice's mount of the session reconciler (@momo/session)
 * on this app's one Firebase app. The backoffice serves Revia's organization
 * alone, so it is open before anyone signs in: a code is sent under it, so
 * only its members receive one, and the actor binds there — grant → role →
 * permissions, with the `mfa` claim the code mints. Staff hold no
 * users/{uid} record, so the session reads them as owing consent; the staff
 * gate (staff.state.ts) admits them on the staff notice instead.
 */
import { mountSession } from "@momo/session";
import { organizationId } from "@momo/views";
import { REVIA_ORG_ID } from "@revia/types";
import { auth, db, functions } from "../firebase.ts";

organizationId.set(REVIA_ORG_ID);
mountSession({ auth, db, functions, opensNamedOrganization: true });
